"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsOfServiceCheckbox = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const polaris_1 = require("@shopify/polaris");
const MSA_LINK = 'https://gomalomo.com/msa-current';
const PRIVACY_LINK = 'https://gomalomo.com/privacy';
const CONTENT_LINK = 'https://gomalomo.com/content-policy';
const StyledContainer = styled_components_1.default.span `
  .terms-of-service-checkbox-label {
    align-items: flex-start;

    > *:first-child {
      margin-top: 2px;
    }
  }
`;
const TermsOfServiceCheckbox = ({ error, id, checked, key, onChange }) => {
    const label = (react_1.default.createElement("span", null,
        "By submitting this form, you agree to the",
        ' ',
        react_1.default.createElement(polaris_1.Link, { url: MSA_LINK }, "Master Services Agreement"),
        " which also references our ",
        react_1.default.createElement(polaris_1.Link, { url: PRIVACY_LINK }, "Privacy Policy"),
        " and",
        ' ',
        react_1.default.createElement(polaris_1.Link, { url: CONTENT_LINK }, "Content Policy"),
        "."));
    return (react_1.default.createElement(StyledContainer, null,
        react_1.default.createElement(polaris_1.Checkbox, { checked: checked, error: error, id: id, key: key, label: label, labelClassName: 'terms-of-service-checkbox-label', onChange: onChange })));
};
exports.TermsOfServiceCheckbox = TermsOfServiceCheckbox;
